import { useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { ClientePn } from '../../models/ClientePn';
import * as generic from '../../components/Generico';
import { ClientePNService } from '../../service/ClientePNService';
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { DatosPn } from './cpn/DatosPn';
import { ActividadPn } from './cpn/ActividadPn';
import { ConyuguePn } from './cpn/ConyuguePn';
import { PepPn } from './cpn/PepPn';
import { PartebPn } from './cpn/PartebPn';
import { AmpliadaPn } from './cpn/AmpliadaPn';
import { DeclaracionPn } from './cpn/DeclaracionPn';
import { useToken } from '../../components/useToken';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { FiltroMultiempresa } from '../../components/FiltroMultiempresa';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../components/AnexosComponent';
import { useLazyParams } from '../../hooks/useLazyParams';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { TablaDinamica } from '../../components/TablaDinamica';
import { DialogInstrucciones } from '../../components/ui/DialogInstrucciones';

export const ClientePerNa = () => {

    const [catalogos, setCatalogos] = useState(null);
    const omodel = new ClientePn({ formularioMatriz: catalogos?.formularioMatriz });
    const model = omodel.model;
    const [permss, setPermss] = useState(null);
    const clientepnSrv = new ClientePNService();
    const [cliente, setCliente] = useState(null);
    const [dialogClientepn, setDialogClientepn] = useState(false);
    const toast = useRef(null);
    const { getPerss, getRol } = useToken();
    const [empresa, setEmpresa] = useState(null);
    const [siCliente, setSiCliente] = useState(false);
    const tablaEstado = useLazyParams({ modelo: model });
    const menuRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [dialogSubir, setDialogSubir] = useState(false);
    const [urls, setUrls] = useState(null);
    const [soloLectura, setSoloLectura] = useState(false);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/clientepn',
            urlDownload: 'ficha/clientepn/descarga',
            urlUpload: 'ficha/clientepn/store',
            udelete: 'ficha/clientepn/eliminar-anexo',
            uactual: 'ficha/clientepn/editar',
            uenviar: 'ficha/clientepn/enviar',
            uaprobar: 'ficha/clientepn/aprobar',
        });
        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined;
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) {
            setPermss(permisosToken);
            editFicha(true);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    // Efecto para observar el inicio del formulario
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogClientepn]); // Dependencia clave: se re-ejecuta cuando abre/cierra el formulario

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        setSoloLectura(isReadOnly);
        const idConsulta = esNotificado ? 0 : cliente?.id;
        const necesitaCatalogos = catalogos === null;

        // Asumiendo que el servicio fue unificado en backend igual que consultarClientepj
        clientepnSrv.consultarClientepn(idConsulta, null, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.clientepn) {
                iniciarNuevo();
                return;
            }

            setDialogClientepn(true);
            setActiveIndex(0);
            setDialogInstruccion(true);

            nuevoCliente({
                id: res.data.clientepn.id,
                nemonico: res.data.clientepn.nemonico,
                civil: res.data.clientepn.civil
            });
        }).finally(() => {
            // Lógica final si es necesaria
        });
    }

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        delete _lazyParams.empresa;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (empresa) {
            _lazyParams.empresa = empresa;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }

        clientepnSrv.getClientepn({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);

            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    // FUNCIÓN VITAL. Actualiza el estado global del cliente actual en el formulario.
    const nuevoCliente = (nuevo) => {
        if (!nuevo) {
            setCliente(null);
            return;
        }
        setCliente(prev => ({ ...prev, ...nuevo }));
    }

    const iniciarNuevo = () => {
        setSoloLectura(false);
        setDialogClientepn(true);
        nuevoCliente(null);
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteCliente()
        });
    }

    const deleteCliente = () => {
        clientepnSrv.eliminarClientepn(cliente?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const regresar = () => {
        setActiveIndex(0);
        setDialogClientepn(false);
        setSoloLectura(false);
        if (!siCliente) {
            loadLazyData();
        }
    };

    const handleNext = () => {
        if (activeIndex < 6) {
            const num = activeIndex === 1 && !cliente?.civil ? 2 : 1;
            setActiveIndex(activeIndex + num);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            const num = activeIndex === 3 && !cliente?.civil ? 2 : 1;
            setActiveIndex(activeIndex - num);
        }
    };

    const mensajeError = (mensaje) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: mensaje, life: 3000 });
    };

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setCliente(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    // Menu del formulario Cliente Persona Natural
    const itemsMenu = () => {
        const items = [];

        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true) } });
        }

        if (permss?.actualizar && (cliente?.nemonico === 'BORRADOR' || cliente?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }

        if (permss?.consultar) {
            items.push({
                label: 'Anexos', icon: 'pi pi-folder-open',
                command: () => {
                    if (!cliente?.siSituacion) {
                        mensajeError("Primero debe seleccionar y guardar la situación laboral en la Sección 2.");
                        return;
                    }
                    setDialogSubir(true);
                }
            });
        }

        if (permss?.eliminar && cliente?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }

        return [{ label: 'Opciones', items: items }];
    };

    const reiniciar = () => {
        if (!siCliente) {
            loadLazyData();
        }
        setDialogClientepn(false);
        setDialogSubir(false);
    }

    const panelHeaderTemplate = () => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-user mr-2"></i>
                    <span className="mr-2">{soloLectura ? 'VER' : cliente?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DE PERSONA NATURAL</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogClientepn && !siCliente && <div className="fadein animation-duration-300">
                {getRol() && getRol()?.ideg && <FiltroMultiempresa loadLazyData={loadLazyData} setEmpresa={setEmpresa} />}
                <Toolbar className="mb-4" start={(getRol() && getRol()?.ideg) ? null : generic.leftToolbarTemplate(iniciarNuevo, 'Nuevo', permss)}
                    end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Reporte_clientes_persona_natural', 'LISTADO CLIENTES PERSONA NATURAL')}></Toolbar>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                </Card>
            </div>
            }

            {dialogClientepn &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Sección 1" rightIcon="pi pi-address-book ml-2">
                                <DatosPn id={cliente?.id} siCliente={siCliente} next={handleNext} permss={permss} catalogos={catalogos} nuevoCliente={nuevoCliente} toast={toast} seccion="seccion1" soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 2" disabled={!cliente?.id} rightIcon="pi pi-warehouse ml-2">
                                <ActividadPn id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} toast={toast} seccion="seccion2" soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 3" disabled={!cliente?.id || !cliente?.civil} rightIcon="pi pi-user ml-2">
                                <ConyuguePn id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} toast={toast} seccion="seccion3" soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 4" disabled={!cliente?.id} rightIcon="pi pi-money-bill ml-2">
                                <PepPn id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} toast={toast} seccion="seccion4" soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 5" disabled={!cliente?.id} rightIcon="pi pi-building-columns ml-2">
                                <PartebPn id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} toast={toast} seccion="seccion5" soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 6" disabled={!cliente?.id} rightIcon="pi pi-shop ml-2">
                                <AmpliadaPn id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} toast={toast} tipo='clientePn' catalogos={catalogos} soloLectura={soloLectura} seccion="seccion6" />
                            </TabPanel>

                            <TabPanel header="Sección 7" disabled={!cliente?.id} rightIcon="pi pi-file ml-2">
                                <DeclaracionPn id={cliente?.id} back={handlePrev} permss={permss} setDialogClientepn={setDialogClientepn} toast={toast} seccion='seccion7'
                                    cancelar={getPerss() === undefined} setdialogIns={setDialogInstruccion} urls={urls} estado={cliente?.nemonico} reiniciar={reiniciar}
                                    catalogos={catalogos} soloLectura={soloLectura} />
                            </TabPanel>
                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }

            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />

            <Dialog visible={dialogSubir} header="Gestión de anexos" modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="clientePn" urls={urls} idp={cliente?.id} toast={toast} permss={permss} setDialogSubir={setDialogSubir} reiniciar={reiniciar}
                    loadLazyData={loadLazyData} estado={cliente?.nemonico} />
            </Dialog>
        </>
    )
}